import _ from 'lodash';
import PropTypes from 'prop-types';


import { MemoComments } from '../../framework.core/MemoComment';
import { ApplicableTableSettings, memoCommentList } from '../../tableSettings';
import { formatDateTime, now } from '../../dateUtils';
import { Memo } from '../../framework.core/Memo';
import TextBox from '../../ui/TextBox';
import EditableTable, { CellData, TableCellTypes } from '../../ui/tables/editing/EditableTable';
import useSystemSettings from '../../hooks/useSystemSettings';

function CommentRenderer({row, data }: any) {
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
  return (
    <TextBox
      maxLength={250}
      textId={`ifms-comment-${row.index}-${data[0].tableName}`}
      value={l.comment}
      onChange={e => changeLineItem(row.index, { comment: e.target.value})}
    />
  );
}

function CommentTable({
  onChange,
  isViewMode,
  memo
}: {
  onChange: (x: Partial<Memo>) => void,
  isViewMode: boolean,
  memo: Memo
}) {
  const commentList = memo.commentList;
  const systemSettings = useSystemSettings();
  
  function changeLineItem(index:number, change:Partial<MemoComments>) {
    commentList[index] = _.merge(commentList[index], change);
    onChange({commentList});
  }

  function deleteRow(index: number): boolean {
    if (isViewMode) {
      return false;
    }

    commentList.splice(index, 1);
    onChange({commentList});

    return true;
  }

  function addLineItem() {
    const newItem = new MemoComments({
      tbId: memo.id,
      u1ID: systemSettings?.userId??'',
      u1Date: now(),
      u2ID: systemSettings?.userId??'',
      u2Date: now(),
    });
    newItem.trackable = true;
    return {
      setDataFunc: (list: any) => onChange({commentList: list}),
      curListData: commentList,
      newData: newItem
    };
  }

  const tableOptions: ApplicableTableSettings = {
    customTableId: 'memoComment',
    tableName: 'memoComment',
    ...memoCommentList,
    data: commentList.map((x, i) => ({ ...x, i, changeLineItem, isViewMode})),
    useEditControls: !isViewMode,
    rowRenderers: [
      { accessor: 'indicator' },
      { accessor: 'comment', EditCell: CommentRenderer },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
      const curRowData = rowData as MemoComments;
       if  (accessor === 'comment') 
        return { type: TableCellTypes.Text, value: curRowData.comment };
      else
        return undefined;
    },
    isCellLock: (accessor: string, rowData: any): boolean => {
      if (accessor === 'comment' && rowData.isViewMode){
        return true;
      }
      else 
      return false;
    },
    height: '142px',
    //useTableHelperText: !isViewMode,
    isModalTable: true,
  };

  return (
        <EditableTable
          tableOptions={tableOptions}
          deleteLine={deleteRow}
          addLine={addLineItem}
        />
  );
}

CommentTable.propTypes = {
  onChange: PropTypes.func.isRequired
};
export default CommentTable;
